import { z } from 'zod';

export const EmailForwardingSearchSchema = z.object({ url: z.string().optional() }).default({ url: '' });

export type EmailForwardingSearchSchemaType = z.infer<typeof EmailForwardingSearchSchema>;
